import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-[#f7f5f2]">
      <Helmet>
        <title>Impressum | Rieppel Bäckerei GmbH – Cafe Konditorei Rieppel Wien</title>
        <meta name="description" content="Impressum der Rieppel Bäckerei GmbH. Geschäftsführer: Ercifci Yüksel. Märzstraße 71/1-7, 1150 Wien." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://rieppel-baeckerei.at/impressum" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Startseite", "item": "https://rieppel-baeckerei.at/" },
            { "@type": "ListItem", "position": 2, "name": "Impressum" }
          ]
        })}</script>
      </Helmet>

      {/* Header */}
      <header className="bg-[#1e1919] text-white py-4 sm:py-6 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-testid="back-to-home">
            <ArrowLeft className="w-5 h-5" />
            <span className="hidden sm:inline">Zurück zur Startseite</span>
          </Link>
          <h1 className="font-bold text-lg sm:text-xl">Impressum</h1>
          <div className="w-20 sm:w-32"></div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1e1919] mb-8 sm:mb-10">Impressum</h1>

        <div className="space-y-8 sm:space-y-10">
          {/* Unternehmen */}
          <section data-testid="impressum-company">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Angaben gemäß § 5 ECG</h2>
            <div className="space-y-1 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p className="font-semibold text-[#1e1919]">Rieppel Bäckerei GmbH</p>
              <p>Märzstraße 71/1-7</p>
              <p>1150 Wien, Österreich</p>
            </div>
          </section>

          {/* Kontakt */}
          <section data-testid="impressum-contact">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Kontakt</h2>
            <div className="space-y-1 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>Telefon: <a href="tel:+4319825285" className="text-[#61525a] hover:text-[#1e1919] transition-colors">01 9825285</a></p>
              <p>E-Mail: <a href="mailto:yukselercifci73@gmail.com" className="text-[#61525a] hover:text-[#1e1919] transition-colors">yukselercifci73@gmail.com</a></p>
            </div>
          </section>

          {/* Geschäftsführung */}
          <section data-testid="impressum-management">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Geschäftsführung</h2>
            <div className="space-y-1 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p className="font-semibold text-[#1e1919]">Ercifci Yüksel</p>
              <p>Alleinvertretungsberechtigt</p>
            </div>
          </section>

          {/* Gewerberechtlicher Geschäftsführer */}
          <section data-testid="impressum-trade-manager">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Gewerberechtlicher Geschäftsführer</h2>
            <div className="space-y-1 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p className="font-semibold text-[#1e1919]">Stefan Rieppel</p>
              <p>Bestellt am: 07.05.2024</p>
            </div>
          </section>

          {/* Firmenbuch */}
          <section data-testid="impressum-register">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Firmenbuchdaten</h2>
            <div className="space-y-1 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>Rechtsform: Gesellschaft mit beschränkter Haftung (GmbH)</p>
              <p>Firmenbuchnummer: FN 608837 z</p>
              <p>Firmenbuchgericht: Handelsgericht Wien</p>
              <p>GLN: 9110033849901</p>
              <p>Beginndatum der Rechtsform: 21.06.2023</p>
            </div>
          </section>

          {/* Gewerbe */}
          <section data-testid="impressum-trade">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Gewerbeberechtigung</h2>
            <div className="space-y-1 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>Gewerbeart: Reglementiertes Gewerbe</p>
              <p>Gewerbewortlaut: Bäcker (Handwerk)</p>
              <p>Standort: 1150 Wien, Märzstraße 71/1-7</p>
              <p>Entstehung: 07.05.2024</p>
            </div>
          </section>

          {/* Tätigkeit */}
          <section data-testid="impressum-activities">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Tätigkeitsbeschreibung</h2>
            <div className="text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>Betrieb einer Bäckerei, Betrieb von Gastronomiebetrieben, Handel mit Waren aller Art.</p>
            </div>
          </section>

          {/* Aufsichtsbehörde */}
          <section data-testid="impressum-authority">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Behörde gem. ECG</h2>
            <div className="text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>Magistratisches Bezirksamt des XV. Bezirkes</p>
            </div>
          </section>

          {/* Haftungsausschluss */}
          <section data-testid="impressum-disclaimer">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Haftungsausschluss</h2>
            <div className="space-y-3 text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>
                Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit 
                und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              </p>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 ECG für eigene Inhalte auf diesen Seiten nach den allgemeinen 
                Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen 
                zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </div>
          </section>

          {/* Urheberrecht */}
          <section data-testid="impressum-copyright">
            <h2 className="text-lg sm:text-xl font-bold text-[#1e1919] mb-3 border-b border-[#e5e2df] pb-2">Urheberrecht</h2>
            <div className="text-[#736c64] text-sm sm:text-base leading-relaxed">
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen 
                Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen 
                des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </section>
        </div>

        {/* Back Link */}
        <div className="mt-12 pt-8 border-t border-[#e5e2df]">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#61525a] hover:text-[#1e1919] transition-colors font-medium"
            data-testid="impressum-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
        </div>
      </main>
    </div>
  );
};

export default ImpressumPage;
